var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-input-theme flex justify-between gap-3 pr-2",class:[
    _vm.focus ? 'border-theme-blue' : '',
    _vm.icon ? 'pl-10' : '',
    _vm.disabled ? 'disabled' : 'cursor-text',
  ],on:{"click":function($event){$event.stopPropagation();return _vm.focusInput.apply(null, arguments)}}},[(_vm.icon)?_c('span',{staticClass:"shrink-0 flex items-center pointer-events-none"},[_c('SaIcon',{attrs:{"name":_vm.icon}})],1):_vm._e(),_vm._v(" "),_vm._t("default",null,{"focusin":_vm.focusIn,"focusout":_vm.focusOut})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }